import { Avatar, Breadcrumb, Button, Col, Form, Input, Row, Spin, Upload } from 'antd';
import { getCurrentSitter, updateProfile } from '../../lib/api-client.ts';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

export const SettingProfilePage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { data: sitter } = useQuery({ queryKey: ['self'], queryFn: getCurrentSitter });
  const { mutate, isPending } = useMutation({ mutationFn: updateProfile });
  const avatar = Form.useWatch('avatar', form);

  useEffect(() => {
    if (sitter) {
      form.setFieldsValue({
        ...sitter,
        avatar: {
          fileList: [
            {
              uid: sitter.avatar.id,
              name: sitter.avatar.id,
              status: 'done',
              url: sitter.avatar.url,
              thumbUrl: sitter.avatar.url,
              response: {
                id: sitter.avatar.id,
                url: sitter.avatar.url,
              },
            },
          ],
        },
      });
    }
  }, [sitter]);

  if (!sitter) return <Spin />;

  const handleSubmit = async (values: any) => {
    mutate(
      {
        name: values.name,
        university: values.university,
        avatar: values.avatar && {
          id: values.avatar.fileList[0].response.id,
          url: values.avatar.fileList[0].response.url,
        },
      },
      {
        onSuccess: () => {
          navigate('/settings');
        },
      },
    );
  };

  return (
    <>
      <Breadcrumb
        style={{ margin: 16 }}
        items={[
          { title: <Link to="/">ホーム</Link> },
          { title: <Link to="/settings">設定</Link> },
          { title: 'シッター情報' },
        ]}
      />
      <Form
        name="sitter-profile-form"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        autoComplete={'off'}
        onFinish={handleSubmit}
        onFinishFailed={console.error}
        disabled={isPending}
      >
        <Row gutter={[16, 16]} style={{ margin: 16 }}>
          <Col span={24}>
            <Form.Item name="avatar" label="アバター">
              <Upload
                disabled
                name="files"
                action={`${import.meta.env.VITE_API_URL}/blobs`}
                listType="picture-circle"
                accept="image/*"
                fileList={avatar?.fileList || []}
                multiple={false}
                showUploadList={false}
                maxCount={1}
              >
                {avatar?.fileList[0]?.status === 'done' ? (
                  <Avatar src={avatar.fileList[0].response?.url} size={90} />
                ) : (
                  <button style={{ border: 0, background: 'none' }} type="button">
                    {avatar?.fileList[0].status === 'uploading' ? (
                      <LoadingOutlined />
                    ) : (
                      <PlusOutlined />
                    )}
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </button>
                )}
              </Upload>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="name" label="名前" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="university" label="大学" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isPending}
              onClick={() => form.submit()}
            >
              保存
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
};
